namespace Dashboard {

    export class DashboardBookingDetails {

        bookingId: number;
        bookingTypeMap: {[key:string]:number};
        bookingInfoItemType: {[key:string]:number};

        isAtolProtectedBooking: boolean;
        displaySupplierRef: boolean;
        childActions: any;
        bookedItems: any;
        packageCost: any;
        template: any;
        booking: any;
        pah: {Amount: number, CurrencyCode: string};
        bk: any;
        leadPassengerEmail: string;
        emailSent: boolean;

        constructor(
            private $routeParams:ng.route.IRouteParamsService,
            private dashboardBookingService,
            private imageService,
            private dateUtil,
            private resourceService,
            private paymentsService,
            private mybTrack,
            private authService
        ) {
            this.bookingId = parseInt($routeParams['bookingId'], 10);
            this.bookingTypeMap = dashboardBookingService.getBookingTypeMap();
            this.bookingInfoItemType = dashboardBookingService.getBookingInfoItemType();
            this.getBookingInfo();
            this.getBookingDetail();
        }

        getBookingInfo():void {
            this.dashboardBookingService.getBookingInfo(this.bookingId)
            .then((booking:any) => {
                this.booking = booking;
                this.pah = this.dashboardBookingService.getPahFromNotifications(booking.Notifications);

                if (booking.BookingOptions && booking.BookingOptions.Actions) {
                    this.childActions = this.dashboardBookingService
                        .getChildActions(booking.BookingOptions.Actions, 'VIEWBOOKINGDETAILS');
                }
            });
        }

        resendEmailToLead(): void {
            this.dashboardBookingService.sendConfirmationEmail([this.leadPassengerEmail], this.bookingId).then(res => {
                this.emailSent = true;
                this.mybTrack.track('MYB - Resend Email');
            });;
        }

        getBookingDetail():void {
            this.dashboardBookingService.getBookingDetail(this.bookingId, true)
            .then((data:any) => {
                this.bk = data;
                this.leadPassengerEmail = data.LeadPassenger.Email;
                this.template = data.Itineraries ?
                    `partials/dashboard/ItineraryTemplate?Type=${data.Booking.LongType.template}` : null;

                this.displaySupplierRef = data.BalanceDueInfo ?
                    !(data.Booking.Type === 1 && data.BalanceDueInfo.BalanceDueAmount >
                        TRPCONFIG.Domain.SupplierRefBalanceThreshold) : true;

                 if (data.BookedItemAndPackageCost) {
                    this.packageCost = (TRPCONFIG.Domain.PackagePrice || data.PackageId)
                        && data.BookedItemAndPackageCost.PackageCost;
                    this.isAtolProtectedBooking = data.BookedItemAndPackageCost.IsAtolProtected;
                    this.bookedItems = data.BookedItemAndPackageCost.BookedItems;
                }

                this.mybTrack.track('MYB - View Booking Details', {
                     PaidInFull: this.bk.BalanceDueInfo === null ? true : false
                });

                _.forEach(this.bk.ClearedPayments, (p:any) => {
                    p.LogoName = _.first(this.paymentsService.getLogosList([{ Title: p.CardTypeTitle }])) || 'external';
                });
            });
        }

        actionClick(action:{[key:string]:any}, bk:{[key:string]:any}):void {
            this.dashboardBookingService.actionClick(action, bk);
        }

        getResourceValue(resource:string):string {
            return this.resourceService.get(resource);
        }

        getPaymentTitle(payment){
            return `${payment.CardTypeTitle != null ?
                payment.CardTypeTitle : payment.Title != null ? payment.Title : ''}`;
        }

        signOut() {
            this.authService.signOut();
        }
    }

    angular
        .module('dashboard')
        .controller('DashboardBookingDetails', DashboardBookingDetails);
}
